import clsx from 'clsx';
import * as style from './Loading.css';
import { Spinner } from '@cian/ui-kit';

interface ILoadingProps {
  isBanner?: boolean;
}

export const Loading: React.FC<ILoadingProps> = ({ isBanner }) => {
  return (
    <div className={clsx(style['container'], isBanner && style['banner'])}>
      <Spinner />
    </div>
  );
};
